import React from "react";
import { img_path } from "../../../environment";

type BrandLogoProps = {
  size?: "sm" | "md" | "lg";
  showName?: boolean;
  className?: string;
  src?: string;
};

export type BrandWordmarkSize = "md" | "lg" | "title" | "xl";

const SIZE_PX: Record<NonNullable<BrandLogoProps["size"]>, number> = {
  sm: 32,
  md: 40,
  lg: 88,
};

export const BrandWordmark: React.FC<{
  size?: BrandWordmarkSize;
  className?: string;
}> = ({ size = "md", className = "" }) => (
  <span
    className={`unocampus-brand__name unocampus-brand__name--${size} ${className}`.trim()}
    aria-label="UnoCampus 360"
  >
    <span className="unocampus-brand__word">
      <span className="unocampus-brand__uno">Uno</span>
      <span className="unocampus-brand__campus">Campus</span>
    </span>
    <span className="unocampus-brand__360">360</span>
  </span>
);

const BrandLogo: React.FC<BrandLogoProps> = ({
  size = "md",
  showName = false,
  className = "",
  src = "assets/img/logo.png",
}) => {
  const px = SIZE_PX[size];

  return (
    <span className={`unocampus-brand unocampus-brand--${size} ${className}`.trim()}>
      <img
        src={`${img_path}${src}`}
        alt="UnoCampus 360"
        width={px}
        height={px}
        decoding="async"
        style={{
          width: px,
          height: px,
          objectFit: "contain",
          background: "transparent",
        }}
      />
      {showName ? <BrandWordmark size={size === "lg" ? "lg" : "md"} /> : null}
    </span>
  );
};

export default BrandLogo;
